module.exports = __webpack_public_path__ + "static/billing-journey-7360e49b8786435a5d8229c74c155b24.svg";